import { render, staticRenderFns } from "./voluntariado.vue?vue&type=template&id=1a1f1713"
import script from "./voluntariado.vue?vue&type=script&lang=js"
export * from "./voluntariado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports